import { Controller } from "@hotwired/stimulus"

// Single-active source pill filter for the §3 imagery overlap grid.
// All four grids are pre-rendered in the DOM; this controller swaps which
// one is visible and which pill carries the active styling.
export default class extends Controller {
  static targets = ["pill", "grid"]

  select(event) {
    event.preventDefault()
    const source = event.currentTarget.dataset.source

    this.pillTargets.forEach(pill => {
      const active = pill.dataset.source === source
      pill.classList.toggle("bg-br-navy", active)
      pill.classList.toggle("text-white", active)
      pill.classList.toggle("border", !active)
      pill.classList.toggle("border-br-line", !active)
      pill.classList.toggle("text-br-gray", !active)
      pill.classList.toggle("font-semibold", active)
      pill.classList.toggle("font-medium", !active)
    })

    this.gridTargets.forEach(grid => {
      grid.classList.toggle("hidden", grid.dataset.source !== source)
    })
  }
}
